import createReactComponent from '../createReactComponent';
export default createReactComponent('currency-tugrik', 'IconCurrencyTugrik', [
  ['path', { d: 'M7 6h10', key: 'svg-0' }],
  ['path', { d: 'M12 6v13', key: 'svg-1' }],
  ['path', { d: 'M8 17l8 -3', key: 'svg-2' }],
  ['path', { d: 'M16 10l-8 3', key: 'svg-3' }],
]);
